/**
* @name: page-bg-img-sel
* @author: weiyong
* @date: 2023-03-31 20:45
* @description：page-bg-img-sel
* @update: 2023-03-31 20:45
*/
<template>
  <div :class="prefixCls" class="themeAttr-item">
    <div class="themeAttr-item-body flex-div">
      <div class="layout-item" @click="selItem(item)"
           :class="item.imgSrc===activeKey?'active':''" v-for="item in layoutAry">
        <div class="item-type-sign-img">
          <img
            :src="item.imgSrc"
            alt="自适应">
          <span class="layoutItem-type-sign-cuntermark"></span>
          <span class="layoutItem-type-sign-icon"><check-outlined/></span>
        </div>
      </div>
    </div>

    <div class="backgroundSettings">
      <div class="backgroundSettings-name">{{t('图片模糊度')}}</div>
      <a-slider id="test" v-model:value="bgFilterVal"/>
    </div>

    <div class="backgroundSettings">
      <div class="backgroundSettings-name flex-div-bet">
        <div class="flex-div">
          <div style="margin-right: 12px;">{{t('图片蒙版')}}</div>
          <use-sel-color ref="useSelCtrl" @selItem="selMaskColorItem"/>
        </div>
      </div>
      <a-slider id="test" v-model:value="bgOpacity"/>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "page-bg-img-sel",
});
</script>

<script lang="ts" setup>
import UseSelColor from "@/views/dashboard/analysisSet/components/use-sel-color.vue";
import {Slider as aSlider} from "ant-design-vue";
import {CheckOutlined} from "@ant-design/icons-vue";
import {useDesign} from "@/hooks/web/useDesign";
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {useHeaderSetting} from "@/hooks/setting/useHeaderSetting";
import {useI18n} from "vue-i18n";

const {t} = useI18n();
const {
  getPageBgOpAcityVal,
  getPageBgFilterVal,
} = useHeaderSetting();

const props=defineProps({
  curImg:{}
})
const emits=defineEmits(['setLayout'])
const layoutAry = [
  {id: 'defaultFrameCom', name: '经典模式',imgSrc:'/static/bgImg/1.jpeg'},
  // {id: 'appFrame', name: '应用模式',imgSrc:'/static/bgImg/2.jpeg'},
  {id: 'defaultFrameTop', name: '头部菜单',imgSrc:'/static/bgImg/3.jpeg'},
  {id: 'defaultFrameLevel', name: '二级菜单',imgSrc:'/static/bgImg/4.jpeg'},
  // {id: '红色政务', name: '红色政务',imgSrc:'/static/bgImg/5.jpeg'},
]

const {prefixCls} = useDesign('page-bg-img-sel');

const activeKey = ref(props.curImg);
//选择背景图片
const selItem = function (item) {
  activeKey.value = item.imgSrc;
  baseHandler(HandlerEnum.BACK_GROUND_IMG_SRC, unref(item).imgSrc);
}
//选择蒙层的颜色
const selMaskColorItem = function (item) {
  activeKey.value = item.id;
  baseHandler(HandlerEnum.BACK_MASK_COLOR, unref(item).id);
}
//背景蒙层透明度
const bgOpacity=ref(unref(getPageBgOpAcityVal));
//图片的模糊度
const bgFilterVal=ref(unref(getPageBgFilterVal));

watch(bgOpacity,(newVal)=>{
  baseHandler(HandlerEnum.BACK_OPACITY_VAL, unref(newVal));
})
watch(bgFilterVal,(newVal)=>{
  baseHandler(HandlerEnum.BACK_FILTER_VAL, unref(newVal));
})
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-page-bg-img-sel';

.@{prefix-cls} {
  width: 100%;
  margin-bottom: 10px;
  border-radius: 6px;
  background: #fff;
  font-family: PingFangSC-Semibold, PingFang SC;

  .backgroundSettings{
    .color-div{
      height: 20px !important;
    }
    .changSketch{
      top:0 !important;
    }
  }

  .backgroundSettings-name {
    min-width: 72px;
    height: 28px;
    font-size: 12px;
    font-weight: 400;
    color: #2b2c42;
    line-height: 28px;
  }

  .themeAttr-item-body {
    flex-wrap: wrap;
  }

  .layout-item {
    position: relative;
    cursor: pointer;
    margin-bottom: 12px;

    &.active {
      .item-type-sign-img {
        border: 1px solid #ff2121;
      }

      .layoutItem-type-sign-cuntermark {
        border-color: #ff2121 #ff2121 transparent transparent;
      }

      .layoutItem-type-sign-icon {
        color: #fff;
      }
    }

    .layoutItem-type-sign-icon {
      position: absolute;
      top: -1px;
      right: 0.5px;
      width: 20px;
      height: 20px;
      font-size: 9px;
      z-index: 2;
      color: transparent;
      font-weight: bold;
    }

    .layoutItem-type-sign-cuntermark {
      position: absolute;
      top: 0;
      right: 13px;
      width: 16px;
      height: 16px;
      border: 8px solid transparent;
      z-index: 1;
    }
  }

  .themeAttr-item-title {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #111;
    margin-bottom: 14px;
  }

  .itme-title-span {
    text-align: center;
    margin-top: 6px;
  }

  .item-type-sign-img {
    width: 70px;
    height: 32px;
    padding: 3px;
    border: 1px solid #fff;
    border-radius: 3px;
    margin-right: 12px;
    img{
      width:66px;
      height:24px;
    }
  }
}
</style>
